import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitodamantaxi() {



  const cardData =
  {
    keyword: 'Mumbai to Daman Taxi ',
    heading: 'Shambhu Cabs: Mumbai to Daman Taxi',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Daman Taxi services, providing safe, comfortable, and hassle-free travel for families, friends, corporate travelers, and holiday seekers heading to the coastal destination of Daman. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Daman with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, professional chauffeurs, and 24/7 booking support, Shambhu Cabs makes your trip convenient and stress-free. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Daman taxi services for travelers seeking comfort, safety, punctuality, and a reliable travel experience.',

    top: 'Top Places to Visit in Daman with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Devka Beach",
    "description": "Devka Beach is one of Daman’s most visited coastal spots, known for its flat shoreline, black rocks, and refreshing sea breeze. The beach has a long promenade lined with food stalls, amusement rides, and open parks, making it ideal for evening strolls and family outings. While the waters are not always suitable for swimming due to rocky patches, the sunsets here are among the most beautiful in the region. The calm environment and scenic ocean views make Devka Beach a relaxing getaway for tourists."
  },
  {
    "title": "Jampore Beach",
    "description": "Jampore Beach, located near Moti Daman, is famous for its clean coastline, soft sands, and shallow waters that are perfect for bathing and beach sports. The beach is known for its peaceful atmosphere as it lies further away from the crowded areas of the city. Visitors enjoy horse rides, ATV bikes, parasailing, and local seafood delicacies served at beachside shacks. The dense Casuarina trees surrounding the beach enhance its natural beauty, making it a popular choice for picnics and serene relaxation."
  },
  {
    "title": "Moti Daman Fort",
    "description": "Moti Daman Fort, built by the Portuguese in the 16th century, is one of the region’s most impressive historical structures. Spread across nearly 30,000 square meters, the fort features massive stone walls, bastions, watchtowers, and colonial-style buildings that reflect Daman’s Portuguese heritage. Visitors can explore old government offices, ancient churches, narrow cobbled pathways, and scenic viewpoints overlooking the Arabian Sea. The fort remains a symbol of Daman’s rich maritime history and colonial architecture."
  },
  {
    "title": "Nani Daman Fort",
    "description": "Nani Daman Fort, though smaller than Moti Daman Fort, is equally captivating with its peaceful surroundings and beautiful riverfront views. The fort houses a Portuguese-style cemetery, old administrative buildings, and an iconic giant gateway that welcomes visitors. The highlight is the St. Jerome Church inside the fort complex, known for its intricate façade and serene ambiance. Its proximity to the Daman Ganga River makes it a picturesque heritage attraction."
  },
  {
    "title": "St. Jerome Church",
    "description": "St. Jerome Church, also known as the Church of Our Lady of the Sea, is one of Daman’s most significant Christian religious sites. Built in 1614, the church features stunning Portuguese architecture, a beautifully carved altar, and peaceful interiors perfect for prayer and meditation. The church façade is particularly striking, decorated with sculptures and gothic-style design elements. St. Jerome Church stands as a proud reminder of Daman’s deep-rooted colonial and spiritual legacy."
  },
  {
    "title": "Dominican Monastery Ruins",
    "description": "The Dominican Monastery Ruins are among Daman’s most mysterious and historically rich attractions. Once a thriving center of theological studies and religious training, the monastery was abandoned centuries ago and now stands as a haunting yet beautiful set of ruins. The broken arches, pillars, and walls covered in greenery give it an atmospheric charm. It is often compared to Europe’s ancient monastery ruins and remains a favorite spot for photographers, history enthusiasts, and explorers."
  },
  {
    "title": "Jetty Garden",
    "description": "Jetty Garden is a beautifully maintained waterfront park located near the Moti Daman Jetty. Featuring lush lawns, musical fountains, walking paths, and play areas, it is a perfect destination for families and couples. The garden also offers boat rides on the Daman Ganga River, providing scenic views of the surrounding fort walls and coastal landscape. Evening lighting enhances its beauty, making it a peaceful place to unwind."
  },
  {
    "title": "Daman Lighthouse",
    "description": "The Daman Lighthouse stands tall on the Moti Daman Fort premises and offers panoramic views of the Arabian Sea and the city. The lighthouse plays an important role in maritime navigation and is a popular tourist spot due to its vantage point. Visitors can walk around the area to enjoy cool sea winds, scenic photography spots, and glimpses of passing fishing boats. The surrounding fort walls enhance the charm of this coastal landmark."
  },
  {
    "title": "Satya Sagar Udyan",
    "description": "Satya Sagar Udyan is a well-landscaped garden located near the Devka Beach area. Filled with fountains, flower beds, sculptures, and sitting areas, the garden provides a quiet escape for visitors looking for a peaceful environment. Its clean surroundings and relaxing greenery make it a suitable place for morning walks, family picnics, and photography. The garden’s proximity to the sea adds a pleasant coastal atmosphere."
  },
  {
    "title": "Cathedral of Bom Jesus",
    "description": "The Cathedral of Bom Jesus, built in the early 17th century, is one of Daman’s most important churches and a masterpiece of Portuguese craftsmanship. The interiors feature intricately designed wooden altars, religious paintings, and a towering carved façade that reflects colonial-era artistry. The cathedral continues to hold regular masses and remains a spiritual center for the local Christian community. Its heritage significance and serene ambiance make it a must-visit attraction for cultural and historical explorers."
  }
],




"services": [
  {
    "name": "Mumbai Daman Taxi",
    "description": "Mumbai Daman Taxi provides reliable, comfortable, and safe long-distance travel from Mumbai to Daman. With expert chauffeurs, clean vehicles, and smooth highway driving, this service is perfect for family trips, coastal getaways, business visits, and weekend holiday plans. The Mumbai–Daman route is well-connected via NH48, ensuring a convenient and enjoyable journey for every traveler."
  },
  {
    "name": "Daman Cab from Mumbai",
    "description": "Daman Cab from Mumbai offers door-to-door pickup and drop service for travelers heading to Daman’s beaches, resorts, and tourist spots. The service includes multiple vehicle choices, transparent pricing, and professional drivers familiar with the Mumbai–Daman route, making it ideal for vacations, corporate travel, and leisure road trips."
  },
  {
    "name": "One-Way Cab Mumbai Daman",
    "description": "One-Way Cab Mumbai Daman is designed for travelers who only require a drop at Daman without needing a return service. This option is perfect for tourists checking into Daman hotels, business travelers, and families planning extended stays. It offers flexible timings, quick confirmations, and affordable fares with no hidden charges."
  },
  {
    "name": "Affordable Taxi Mumbai Daman",
    "description": "Affordable Taxi Mumbai Daman provides cost-effective intercity taxi services without compromising comfort or safety. Ideal for budget travelers, students, and families, this service includes well-maintained sedans and fuel-efficient cars to ensure a pocket-friendly yet comfortable travel experience on the Mumbai–Daman route."
  },
  {
    "name": "Best Cab Mumbai Daman",
    "description": "Best Cab Mumbai Daman offers premium-quality long-distance travel with reliable drivers, spacious vehicles, and smooth service. This option ensures excellent comfort, punctuality, and seamless travel coordination, making it one of the most preferred cab choices for both tourists and business travelers heading to Daman."
  },
  {
    "name": "SUV Cab Mumbai Daman",
    "description": "SUV Cab Mumbai Daman provides spacious and powerful SUVs ideal for groups, families, and travelers carrying extra luggage. These vehicles offer superior comfort, higher ground clearance, and stable highway performance, ensuring a relaxed and enjoyable journey across the Mumbai–Daman highway route."
  },
  {
    "name": "Sedan Cab Mumbai Daman",
    "description": "Sedan Cab Mumbai Daman offers economical, comfortable, and smooth sedan options suitable for small families and business travelers. These cars provide excellent mileage, soft suspension, and good seating comfort, making long-distance travel between Mumbai and Daman pleasant and cost-effective."
  },
  {
    "name": "Outstation Cab Mumbai Daman",
    "description": "Outstation Cab Mumbai Daman is perfect for one-way, round trip, and multi-day travel plans. With reliable chauffeurs and well-serviced vehicles, this service supports holiday tours, weekend getaways, resort stays, and business visits. It ensures a flexible, safe, and enjoyable intercity travel experience for all passengers."
  },
  {
    "name": "24×7 Mumbai Daman Cab",
    "description": "24×7 Mumbai Daman Cab ensures round-the-clock availability for early-morning departures, late-night travel, hotel pickups, airport transfers, and emergency outstation requirements. This service provides immediate confirmations, trustworthy drivers, and safe highway travel at any hour of the day or night."
  },
  {
    "name": "Corporate Cab Mumbai Daman",
    "description": "Corporate Cab Mumbai Daman provides professional, punctual, and high-standard travel suitable for business trips, corporate meetings, and executive travel needs. Luxury sedans and SUVs are available with trained chauffeurs offering smooth, efficient, and comfortable travel solutions for corporate clients."
  },
  {
    "name": "Fast Cab Mumbai Daman",
    "description": "Fast Cab Mumbai Daman offers quick pickups, rapid booking confirmations, and optimized highway routes for travelers who need urgent or time-sensitive transportation. With experienced long-distance drivers, the service ensures timely arrivals and smooth travel throughout the journey."
  },
  {
    "name": "Premium Cab Mumbai Daman",
    "description": "Premium Cab Mumbai Daman provides luxury sedans, high-end SUVs, and top-tier chauffeur services for passengers seeking an elite travel experience. This service is ideal for VIP guests, special occasions, business executives, and families who prefer superior comfort and style during their Mumbai–Daman trip."
  },
  {
    "name": "Safe Taxi Mumbai Daman",
    "description": "Safe Taxi Mumbai Daman prioritizes passenger safety with background-verified drivers, sanitized vehicles, GPS tracking, and safe highway driving practices. It is a trusted choice for women travelers, senior citizens, families, and solo passengers seeking secure long-route transportation."
  },
  {
    "name": "Family Cab Mumbai Daman",
    "description": "Family Cab Mumbai Daman offers spacious interiors, comfortable seating, luggage space, and family-friendly driving for a pleasant coastal journey. This option is suitable for beach vacations, family functions, weekend trips, and resort stays in Daman and nearby locations."
  },
  {
    "name": "Mumbai Daman Pickup Drop",
    "description": "Mumbai Daman Pickup Drop provides convenient point-to-point transfers from any location in Mumbai to Daman. With doorstep pickup, flexible scheduling, and clean vehicles, this service is ideal for airport travelers, hotel guests, business visitors, and families requiring simple and seamless transportation."
  },
  {
    "name": "Long Route Cab Mumbai Daman",
    "description": "Long Route Cab Mumbai Daman is specifically designed for comfortable long-distance travel, ensuring steady driving, smooth vehicle performance, and stress-free transit over the extended highway route. Perfect for tourists, corporate travelers, and families seeking a relaxed journey."
  },
  {
    "name": "Mumbai to Devka Beach Cab",
    "description": "Mumbai to Devka Beach Cab offers direct transportation to one of Daman’s most popular coastal attractions. Ideal for beach lovers, tourists, and family groups, this service ensures a comfortable ride, flexible timings, and safe travel directly to Devka Beach hotels, resorts, and local sightseeing points."
  }
],

"tableData": [
  ["Mumbai Daman Taxi", "Daman Cab from Mumbai"],
  ["One-Way Cab Mumbai Daman", "Affordable Taxi Mumbai Daman"],
  ["Best Cab Mumbai Daman", "SUV Cab Mumbai Daman"],
  ["Sedan Cab Mumbai Daman", "Outstation Cab Mumbai Daman"],
  ["24×7 Mumbai Daman Cab", "Corporate Cab Mumbai Daman"],
  ["Fast Cab Mumbai Daman", "Premium Cab Mumbai Daman"],
  ["Safe Taxi Mumbai Daman", "Family Cab Mumbai Daman"],
  ["Mumbai Daman Pickup Drop", "Long Route Cab Mumbai Daman"],
  ["Mumbai to Devka Beach Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Daman Taxi with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides reliable Mumbai to Daman taxi services, perfect for beach trips, weekend getaways, and smooth intercity travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Enjoy a relaxing journey in spacious, air-conditioned, and well-maintained cabs for your Mumbai to Daman trip."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Highway Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with the Mumbai to Daman route, ensuring safe, smooth, and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We offer upfront and clear taxi fares—fuel, tolls, and driver allowances included—so your Mumbai to Daman taxi journey stays stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and real-time route guidance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Outstation Trips",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans tailored to your Mumbai to Daman travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Every taxi is thoroughly cleaned and sanitized before each journey to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "With timely pickups and dependable service, Shambhu Cabs ensures a smooth and enjoyable Mumbai to Daman taxi ride."
  }
]



























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Daman taxi services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Daman taxi services with trained and experienced drivers.',
  },
  {
    question: 'How can I book a Mumbai to Daman taxi with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for instant booking assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Daman taxi bookings?',
    answer: 'Shambhu Cabs offers a fleet of well-maintained sedans, SUVs, and luxury cars suitable for a smooth and enjoyable trip to Daman.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Daman route?',
    answer: 'Yes, our drivers are licensed, professional, and experienced with the Mumbai to Daman route to ensure a safe and hassle-free journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Daman taxi?',
    answer: 'Absolutely. You can choose your preferred pickup spot in Mumbai and any drop-off location in Daman.',
  },
  {
    question: 'Is the Mumbai to Daman taxi service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Daman taxi booking services to match your travel plans.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Daman taxi bookings?',
    answer: 'All vehicles are regularly sanitized, and drivers follow strict safety and hygiene protocols throughout the journey.',
  },
  {
    question: 'What payment options are available for Mumbai to Daman taxi bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
  },
  {
    question: 'Is customer support available during the Mumbai to Daman journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Daman travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sagar Naik',
    feedback: 'Our Mumbai to Daman taxi experience with Shambhu Cabs was excellent. The ride was smooth and the driver was very courteous.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Rathod',
    feedback: 'Very reliable Mumbai to Daman taxi service. Clean car, punctual driver, and a comfortable journey. Highly recommended!',
    rating: 5,
  },
];















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Daman Taxi",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-daman-cab.jpg",
  "description": "Shambhu Cabs offers reliable and safe Mumbai to Daman taxi services for one-way and round trips. Book sedans, SUVs, or premium cars for family trips, corporate travel, and long-distance journeys. Enjoy 24×7 availability, affordable fares, fast travel, and convenient pickup-drop including Mumbai to Devka Beach.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-daman-taxi"
  }
};








  return (
    <div>
<Helmet>
  <title>Mumbai to Daman Taxi | Outstation & Corporate Cab | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Daman taxi with Shambhu Cabs. Safe, affordable, and comfortable cab service for one-way and round trips, family travel, corporate trips, and long-distance journeys. Available 24×7 with sedans, SUVs, and premium cars, including pickup-drop to Devka Beach."
  />

  <meta
    name="keywords"
    content="Mumbai Daman Taxi, Daman Cab from Mumbai, One-Way Cab Mumbai Daman, Affordable Taxi Mumbai Daman, Best Cab Mumbai Daman, SUV Cab Mumbai Daman, Sedan Cab Mumbai Daman, Outstation Cab Mumbai Daman, 24×7 Mumbai Daman Cab, Corporate Cab Mumbai Daman, Fast Cab Mumbai Daman, Premium Cab Mumbai Daman, Safe Taxi Mumbai Daman, Family Cab Mumbai Daman, Mumbai Daman Pickup Drop, Long Route Cab Mumbai Daman, Mumbai to Devka Beach Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/23.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitodamantaxi;